import React, { useCallback, useEffect } from "react";
import { useHistory } from "react-router-dom";
import { Card, Button, Confirm } from "semantic-ui-react";
import "../../styles/lms/filter-tabs.scss";
import { useLMSGlobalReducer } from "./LmsGlobalStore";
import { GlobalConstants } from "../constants/GlobalConstants";

const LMSTabFilter = () => {
  const history = useHistory();
  const [{ tabsFilter, activeTab, activeHistory, confirmOptions }, dispatch] = useLMSGlobalReducer();
  const { allHistory } = activeHistory;
  const tabsToDisplay = tabsFilter?.filter(tab => tab?.title);
  const setConfirmOptions = (confirmOptions) => {
    dispatch({
      type: GlobalConstants.LMSStoreReducerCases.SET_CONFIRM_OPTIONS,
      payload: confirmOptions
    });
  };

  const handleHistoryPush = useCallback(
    (path) => {
      history.push(path?.startsWith("/") ? path : `/${path}`, { isTabClick: true });
    },
    [history]
  );

  const setTabsFilter = (tabsFilter) => dispatch({
    type: GlobalConstants.LMSStoreReducerCases.SET_FILTER_TABS,
    payload: tabsFilter
  });

  const setActiveTab = (tab) => dispatch({
    type: GlobalConstants.LMSStoreReducerCases.SET_ACTIVE_TAB,
    payload: tab
  });

  const removeTab = (tab) => {
    const removeTabFunc = () => {
      dispatch({
        type: GlobalConstants.LMSStoreReducerCases.REMOVE_TAB,
        payload: tab?.id
      });

      if (tab?.id === activeTab?.id) {
        handleHistoryPush("/");
      }
    };

    if (activeTab?.tabHasUpdatedForm) {
      setConfirmOptions({
        isOpen: true,
        func: removeTabFunc
      });

      return;
    }
    else {
      removeTabFunc();
    }
  };

  const setActivePath = (tab) => dispatch({
    type: GlobalConstants.LMSStoreReducerCases.SET_ACTIVE_PATH,
    payload: tab
  });

  useEffect(() => {
    window.history.pushState(null, "", window.location.href);
    const locationPath = location?.pathname?.substring(1);
    const isInitLoad = history.action === "POP" && allHistory[allHistory?.length - 1]?.pathname === location?.pathname;

    if (!history.location?.state?.isGoBack) {
      if (history?.location?.pathname !== "/") {
        const updatedAllHistory = !history?.location?.state?.isTabClick && !isInitLoad ? [...allHistory.map(history => ({ ...history, isCurrent: false })), {
          ...history.location,
          isCurrent: true
        }] : [...allHistory];
        setActivePath({ ...activeTab, path: locationPath, history, allHistory: updatedAllHistory });
        window.onpopstate = function () {
          window.history.go(1);
          const currentPopPosition = updatedAllHistory?.findIndex(history => history?.isCurrent);
          if (updatedAllHistory[currentPopPosition - 1]?.pathname) {
            history.replace(updatedAllHistory[currentPopPosition - 1]?.pathname, { isGoBack: true });
          }
          else {
            removeTab(activeTab);
          }
        };
      } else {
        dispatch({
          type: GlobalConstants.LMSStoreReducerCases.CLEAR_ACTIVE_TAB
        });

        window.onpopstate = function () {
          window.history.go(1);
        };
      }
    }
    else {
      const updateHistory = [] as any[];
      const currentPosition = allHistory?.findIndex(history => history?.isCurrent);
      const newPosition = history.location?.state?.historyIndex !== undefined ? history.location?.state?.historyIndex : currentPosition - 1;
      allHistory?.map((history, index) => {
        if (index <= newPosition) {
          updateHistory.push({ ...history, isCurrent: index === newPosition });
        }
      });

      setActivePath({ ...activeTab, path: locationPath, history, allHistory: updateHistory });
      window.onpopstate = function () {
        window.history.go(1);
        if (updateHistory[newPosition - 1]?.pathname) {
          history.replace(updateHistory[newPosition - 1]?.pathname, { isGoBack: true });
        }
        else {
          removeTab(activeTab);
        }
      };
    }
  }, [location?.pathname]);

  const handleRemoveAllClick = () => {
    const removeAllFunc = () => {
      setTabsFilter([]);
      dispatch({ type: GlobalConstants.LMSStoreReducerCases.REMOVE_ALL_TABS });
      handleHistoryPush("");
    };

    if (activeTab?.tabHasUpdatedForm) {
      setConfirmOptions({
        isOpen: true,
        func: removeAllFunc
      });

      return;
    }
    else {
      removeAllFunc();
    }
  };

  const handleClick = (filter) => {
    const setTabFunc = () => {
      handleHistoryPush(filter.path);
      setActiveTab(filter);
    };

    if (activeTab?.tabHasUpdatedForm) {
      setConfirmOptions({
        isOpen: true,
        func: setTabFunc
      });

      return;
    }
    else {
      setTabFunc();
    }
  };

  return (
    <Card fluid className="lms-tabs_filter_list_container">
      {confirmOptions?.isOpen && <Confirm
        size="tiny"
        open={!!confirmOptions?.isOpen}
        onCancel={() => {
          setConfirmOptions({ isOpen: false });
        }}
        onConfirm={() => {
          if (confirmOptions?.func) {
            confirmOptions?.func();
          }

          setConfirmOptions({ isOpen: false });
        }}
        content={confirmOptions?.message || "This page is asking you to confirm that you want to leave - data you have entered may not be saved."}
      />}
      <div className="lms-tabs_filter_list">
        <Button
          className="lms-tabs_filter_home_button lms-tabs_filter_button"
          compact
          onClick={handleRemoveAllClick}
          icon="x"
        />
        {tabsToDisplay?.map((filter, index: number) => {
          return (
            <Button.Group
              key={`${filter.title}_${index}`}
              className="lms-tabs_filter_button_group"
            >
              <Button
                className={`lms-tabs_filter_button${filter.id === activeTab?.id ? " active" : ""}`}
                compact
                onClick={() => handleClick(filter)}
              >
                {filter.title}
              </Button>
              <Button
                compact
                className="lms-tabs_filter_button"
                onClick={() => removeTab(filter)}
                icon="x"
              />
            </Button.Group>
          );
        })}
      </div>
    </Card>
  );
};

export default LMSTabFilter;